import React, { useLayoutEffect } from "react";
import { availability } from "api/product";
import { Col, Container, Row } from "react-bootstrap";
import { DealerContainer } from "./style";
import SelectedProduct from "components/selectedProduct";
import Button from "components/button";
import Loading from "components/loading";
import EmptyState from "components/emptyState";
import Select from "components/select";
const DealerView = ({
  selectedOptions,
  product,
  setDealer,
  selectedDealer,
  next,
  prev,
  showPic,
}) => {
  const [dealers, setDealers] = React.useState(null);
  const [provinces, setProvinces] = React.useState(null);
  const [selectedProvince, setSelectedProvince] = React.useState(null);
  useLayoutEffect(() => {
    const fetchData = async () => {
      await availability(product.id)
        .then((res) => {
          let provincesFromServer = {};
          res.data.forEach((dealer) => {
            if (
              !(dealer.province in provincesFromServer) &&
              dealer.availability
            ) {
              provincesFromServer[dealer.province] = dealer.province_id;
            }
          });
          setProvinces(provincesFromServer);
          setDealers(res.data);
          if (selectedDealer) {
            let resetStatus = false;
            res.data.forEach((dealer) => {
              if (dealer.id === selectedDealer.id) {
                resetStatus = true;
              }
            });
            if (resetStatus) {
              setDealer(null);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchData();
  }, [product.id]);
  const dealersView = () => {
    if (!dealers) {
      return <Loading />;
    } else {
      let total = 0;
      let list = dealers.map((dealer) => {
        if (dealer.availability) {
          total += 1;
          if (Number(dealer.province_id) === Number(selectedProvince)) {
            return (
              <div
                className={`item ${
                  selectedDealer?.id === dealer.id ? "selected" : ""
                }`}
                onClick={() => {
                  setDealer(dealer);
                }}
                key={dealer.id}
              >
                <h5>{dealer.title}</h5>
                <Row>
                  <Col sm={12} md={5}>
                    <div className="text">
                      کد نمایندگی: {dealer.description}
                    </div>
                    <div className="phone">تلفن: {dealer.phone}</div>
                  </Col>
                  <Col sm={12} md={7}>
                    <div className="province-city">
                      استان: {dealer.province} - شهر: {dealer.city}
                    </div>
                    <div className="address">آدرس:
                      <div dangerouslySetInnerHTML={{ __html: dealer.address }} />
                    </div>
                  </Col>
                </Row>
              </div>
            );
          }
        } else {
          return null;
        }
      });
      if (!total) {
        return (
          <EmptyState message="در حال حاضر نمایندگی ای برای فروش وجود ندارد" />
        );
      } else {
        let showedProvinces = () =>
          Object.keys(provinces).map((key) => ({
            id: provinces[key],
            title: key,
          }));
        return (
          <>
            <Select
              onChange={(e) => setSelectedProvince(e.target.value)}
              options={showedProvinces()}
            />
            {list}
          </>
        );
      }
    }
  };
  return (
    <DealerContainer>
      <Container>
        <div className="title">
          <h5>انتخاب نمایندگی</h5>
        </div>
        <SelectedProduct
          showPic={showPic}
          selectedOptions={selectedOptions}
          product={product}
        />
        <div className="notice">
          جهت سهولت در فرآیند تکمیل پرونده، تکمیل وجه و تحویل خودرو، می توانید
          با بررسی لیست شبکه نمایندگی ها از بخش زیر، نزدیکترین نمایندگی به محل
          سکونت خود را مشخص و انتخاب نمایید.
        </div>
        {dealersView()}
        <div className="buttons">
          <Button title="مرحله قبل" onClick={prev} />
          <Button
            title="تایید و ادامه"
            onClick={next}
            disabled={!selectedDealer}
          />
        </div>
      </Container>
    </DealerContainer>
  );
};
export default DealerView;
